export default function notifications(Store, $wamp) {

  var demoData = [
    {id: 1, message: "asasdfdf", type: "chat", user: ""},
    {id: 2, message: "asadfdf", type: "chat", user: ""},
    {id: 3, message: "asdfsdf", type: "chat", user: ""},
    {id: 4, message: "asdfsdf", type: "chat", user: ""},
    {id: 5, message: "asdfsadf", type: "chat", user: ""},
    {id: 6, message: "asdsdff", type: "chat", user: ""},
    {id: 7, message: "assadfdf", type: "chat", user: ""},
    {id: 8, message: "aasdfsdf", type: "chat", user: ""}
  ];

  var notifications = new Store(demoData, function (item) {
    return item.id;
  });

  $wamp.subscribe('org.eggs.get_notifications', function (v) {
    notifications.add(v[0]);
  });

  $wamp.subscribe('org.eggs.remove_notifications', function (v) {
    notifications.remove(v[0]);
  });

  return notifications;
}
